"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _helpers = require("../helpers");

var _Element = _interopRequireDefault(require("../Element"));

var _useStyles = _interopRequireDefault(require("./useStyles"));

var _Hocs = require("../../Hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Elements = function Elements(_ref) {
  var lists = _ref.lists;
  var classes = (0, _useStyles["default"])();
  return /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: classes.wrapper
  }, lists.map(function (list, i) {
    return /*#__PURE__*/_react["default"].createElement(_Element["default"], _extends({
      isFirst: i === 0,
      key: i,
      subtitle1: (0, _helpers.addLeadingZero)(i)
    }, list));
  }));
};

Elements.propTypes = {
  lists: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].string)).isRequired
};

var _default = (0, _Hocs.renderListSafely)(Elements);

exports["default"] = _default;